import { BodyType } from '@domain/types';
import { customClient, type ErrorType } from './mutator/custom-client';
import type {
  GetProcessingNotifications401,
  GetProcessingNotifications422,
  GetProcessingNotificationsParams,
  ProcessingNotifications,
} from './types';

/**
 * @summary list processing_notifications
 */
export const getProcessingNotifications = (params: GetProcessingNotificationsParams) =>
  customClient<ProcessingNotifications>({
    url: `/processing_notifications`,
    method: 'get',
    params,
  });

export const archiveProcessingNotifications = (ids: string[]) =>
  customClient<void>({
    url: `/processing_notifications/archive`,
    method: 'put',
    data: { ids } as BodyType,
  });

export type GetProcessingNotificationsQueryError = ErrorType<
  GetProcessingNotifications401 | GetProcessingNotifications422
>;

/**
 * @summary resend processing_notification
 */
export const resendProcessingNotification = (id: string) =>
  customClient<void>({
    url: `/processing_notifications/${id}/resend`,
    method: 'post',
  });
